export const removeDecimalPoint = (value: number) => Math.round(value * 100)

export const addDecimalPoint = (value: number) => value / 100
